module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("76w15"))).then(() => parcelRequire('8rm4T'));